/**
 * RESPONSIBILITY: the themes an event page may be built from.
 *
 * THESE STRINGS ARE STORED. A theme name is what a saved section says it is, so renaming
 * one silently blanks every section already using it — the same reasoning that makes a
 * flag code permanent. Add freely; rename never.
 *
 * One list, read by three things that must agree: the dropdown an editor picks from, the
 * `showWhen` conditions that decide which fields that pick asks for, and the renderer
 * that draws the result. A second copy of these names is how a theme comes to exist in
 * the editor and nowhere else.
 *
 * There is no `Header` here on purpose. The header is constant — always present, always
 * first, never added or removed — so offering it as a choice would be offering something
 * that cannot be chosen.
 */

export const THEME = {
  Facts: 'Facts',
  Body: 'Body',
  Note: 'Note',
  Schedule: 'Schedule',
  Contacts: 'Contacts',
  Questions: 'Questions',
  Gallery: 'Gallery',
  Video: 'Video',
  Cta: 'Call to action',
  Location: 'Location',
  Related: 'Related events',
  Elsewhere: 'Another site',
  Banner: 'Banner',
} as const;

export type Theme = (typeof THEME)[keyof typeof THEME];

/** The dropdown, in the order an editor is offered them. */
export const SECTION_THEMES = Object.values(THEME);

/**
 * The frame the page is drawn in: how many columns it has, and whether there is a second
 * stack to fill. Sections never choose a column — they belong to the stack they were
 * added to, and where the frame has no second column that stack falls to the bottom of
 * the first rather than disappearing.
 */
export const PAGE_THEME = {
  Normal: 'Normal',
  Rail: 'Register on right',
} as const;

export type PageTheme = (typeof PAGE_THEME)[keyof typeof PAGE_THEME];

export const PAGE_THEMES = Object.values(PAGE_THEME);
